( function ( _s ) {
	_s.fn.splideInit = function () {
		return this.each( el => {
			const _self = _s( el );

            // Prevent double initialization (align with FirebaseProvider which uses .splide)
            const existing = el.splideInstance || el.splide;
            if (existing && typeof existing.refresh === 'function') {
                existing.refresh();
                return;
            }

			// Default configuration - no animations for instant switching
			const defaultConfig = {
				type: 'loop',
				perPage: 1,
				perMove: 1,
				arrows: false,
				pagination: true,
				autoplay: true,
				drag: true,
				draggable: true,
				speed: 600, // No animation - instant transition
                interval: 3000,
				gap: '0px',
				autoHeight: false, // Changed from true to false to respect CSS heights
				height: '100%', // Explicitly set to use parent height
				easing: 'linear', // Linear easing for instant feel
				// rewind: false, // Disable rewind animation
				// rewindSpeed: 0 // No rewind animation
			};

			const style = document.createElement( 'style' );
			style.textContent = `
			.live-match-bg .splide__track{
            max-width:70%;
            }
			@media (max-width: 992px) {
             .live-match-bg .splide__track{
            max-width:unset;
            }
		}

            // @media (max-width: 992px) {
            // .live-match-bg .splide__track{
            // max-width:100%
            // }

            }
                // Ensure Splide track and list prevent overlapping
                .home-hero-container.splide > .match-section .splide__track {
                    overflow: hidden !important;
                    position: relative;
                    width: 100%;
                }
                
                // Disable all transitions and animations for instant switching
                .home-hero-container.splide > .match-section .splide__track,
                .home-hero-container.splide > .match-section .splide__list,
                .home-hero-container.splide > .match-section .splide__slide,
                .home-hero-container.splide > .match-section .splide__slide * {
                    transition: none !important;
                    animation: none !important;
                }
                .home-hero-container.splide > .match-section .splide__track {
                    will-change: auto !important;
                }
                .home-hero-container.splide > .match-section .splide__list {
                    transition: transform 0s !important;
                }
                .home-hero-container.splide > .match-section .splide__slide {
                    opacity: 1 !important; // Remove opacity: 0 during initialization
                    transition: transform 0s, opacity 0s !important;
                    backface-visibility: hidden;
                    -webkit-backface-visibility: hidden;
                    transform: translateZ(0);
                    -webkit-transform: translateZ(0);
                }
                
                .home-hero-container.splide .splide__list {
                    display: flex !important;
                    width: auto !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }
                
                // Ensure all Splide slides are clickable and properly sized
                .home-hero-container.splide > .match-section .splide__slide {
                    pointer-events: auto !important;
                    width: 100% !important;
                    min-width: 100% !important;
                    max-width: 100% !important;
                    flex-shrink: 0 !important;
                    flex-basis: 100% !important;
                    position: relative;
                    box-sizing: border-box;
                }
                
                // Ensure slides don't overlap - let Splide handle positioning
                .home-hero-container.splide .splide__slide {
                    margin: 0 !important;
                    padding: 0 !important;
                }
                
                .home-hero-container.splide > .match-section .splide__slide .live-match-container {
                    pointer-events: auto !important;
                }
                
                .home-hero-container.splide > .match-section .splide__pagination {
                    bottom: 20px !important;
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                    gap: 14px;
                    position: absolute !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    z-index: 20 !important;
                    pointer-events: none !important; // Container doesn't block clicks, only dots do
                    width: auto;
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }

                .home-hero-container.splide > .match-section .splide__pagination li {
                    pointer-events: auto !important;
                    cursor: pointer;
                    list-style: none;
                    display: inline-block;
                }

                .home-hero-container.splide > .match-section .splide__pagination__page {
                    width: 10px !important;
                    height: 10px !important;
                    background: #fff !important;
                    border: none !important;
                    border-radius: 50% !important;
                    transition: none !important;
                    padding: 0 !important;
                    margin: 0 !important;
                    cursor: pointer !important;
                    pointer-events: auto !important;
                    opacity: 1;
                    display: block;
                }

                .home-hero-container.splide > .match-section .splide__pagination__page.is-active {
                    background: #A0FF32 !important;
                    transform: scale(1);
                    width: 12px !important;
                    height: 12px !important;
                }

                .home-hero-container.splide > .match-section .splide__pagination__page:hover {
                    background: #A0FF32 !important;
                    opacity: 0.8;
                    transform: scale(1.1);
                    transition: none !important;
                }

            `;
			document.head.appendChild( style );

			// Get custom config if provided
			const customConfig = _self.attr( 'data-splide' )
				? JSON.parse( _self.attr( 'data-splide' ) )
				: {};

			// Merge configs, with custom config taking precedence
			const config = { ...defaultConfig, ...customConfig };

			try {
				const splideInstance = new Splide( el, config );
                el.splideInstance = splideInstance;
                el.splide = splideInstance;

                splideInstance.on("autoplay:pause", () => {
                    splideInstance.Components.Autoplay.play();
                });


				splideInstance.on( 'mounted', () => {
					_self.addClass( 'is-initialized' );
				} );

				splideInstance.mount();

				if ( config.refresh_on_resize ) {
					_s( window ).on(
						'resize',
						window.debounce( () => {
							splideInstance.refresh();
						}, 100 )
					);
				}

				if ( config.emit_events ) {
					config.emit_events.forEach( evName => {
						splideInstance.on( evName, ( a, b, c ) => {
							_self.trigger( `sp-splide-${ evName }`, {
								newIndex: a,
								prevIndex: b,
								destIndex: c,
							} );
						} );
					} );
				}
			} catch ( error ) {
				console.error( 'Failed to initialize Splide:', error );
			}
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '.home-hero-container.splide' );
		if ( !_elements.length ) return;

		// Immediately set opacity: 1 on all slides to prevent opacity: 0 flash
		_elements.each( el => {
			const slides = el.querySelectorAll( '.splide__slide' );
			slides.forEach( slide => {
				slide.style.opacity = '1';
				slide.style.transition = 'opacity 0s';
			} );
		} );

		// Use global loader so Splide is loaded once site-wide
		window.splideWhenReady( () => {
			_elements.splideInit();
		} );
	} );

	// Re-initialize when content updates
	[ 'fixturesUpdated', 'heroUpdated' ].forEach( eventName => {
		document.addEventListener( eventName, () => {
			const _elements = _s( '.home-hero-container.splide' );
			if ( _elements.length ) {
				_elements.splideInit();
			}
		} );
	} );

	// bfcache: page restored from back-forward cache — Splide layout must be recalculated
	window.addEventListener( 'pageshow', ( event ) => {
		if ( ! event.persisted ) {
			return;
		}
		const _elements = _s( '.home-hero-container.splide' );
		if ( ! _elements.length ) {
			return;
		}
		if ( typeof window.splideWhenReady === 'function' ) {
			window.splideWhenReady( () => {
				_elements.splideInit();
			} );
		}
	} );
} )( window._s );